import * as history from 'history';

const History = history.createBrowserHistory();
export default History;
